export default {
	fetchPlaybooksData({ commit }) {
		commit('loading', 'playbooks', { root: true });

		return new Promise((resolve, reject) => {
			commit('fetching', 'playbooks', { root: true });

			this._vm.$api
				.get('playbooks')
				.then(({ body }) => {
					commit('doneFetching', 'playbooks', { root: true });
					commit('setPlaybooks', body);

					resolve();
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {
					commit('doneLoading', 'playbooks', { root: true });
				});
		});
	},
	fetchRecommendationsData({ commit }) {
		commit('loading', 'playbookRecommendations', { root: true });

		return new Promise((resolve, reject) => {
			commit('fetching', 'playbookRecommendations', { root: true });

			this._vm.$api
				.get('playbooks/recommendations')
				.then(({ body }) => {
					commit('doneFetching', 'playbookRecommendations', { root: true });
					commit('setRecommendations', body);
					resolve();
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {
					commit('doneLoading', 'playbookRecommendations', { root: true });
				});
		});
	},
};
